import React from 'react';
import { Typography, Radio } from '@mui/material';

interface StandingOptionsProps {
  windowFnValues: any;
  setWindowFnValues: (fn: (prevState: any) => any) => void;
  ranks: string[];
  orders: string[];
  radioButton: any;
}

const StandingOptions: React.FC<StandingOptionsProps> = ({
  windowFnValues,
  setWindowFnValues,
  ranks,
  orders,
  radioButton,
}) => {
  return (
    <div className="MenuSize">
      <div className="standingMain">
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 'bold',
            color: 'primary.main',
            paddingLeft: '15px',
          }}
        >
          Rank
        </Typography>
        {ranks.map((option, index) => (
          <div
            className="commonOption1"
            key={index}
            data-testid={`rank-option-${option}`}
            style={{ marginBottom: '0px', cursor: 'pointer' }}
            onClick={(e) =>
              setWindowFnValues((prevState: any) => ({
                ...prevState,
                rank: option,
              }))
            }
          >
            <Radio
              size="small"
              data-testid={`rank-radio-${option}`}
              checked={windowFnValues.rank === option}
              value={option}
              sx={{
                ...radioButton,
                marginTop: '0',
                paddingTop: '0',
                paddingLeft: '15px',
              }}
            />
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '12px',
                marginTop: '0',
                paddingBottom: '7px',
              }}
            >
              {option}
            </Typography>
          </div>
        ))}
      </div>

      <div>
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: '600',
            color: 'rgb(96, 96, 96)',
            paddingLeft: '15px',
            marginTop: '2px',
          }}
        >
          Order
        </Typography>
        {orders.map((option, index) => (
          <div
            className="commonOption1"
            key={index}
            data-testid={`order-option-${option}`}
            style={{cursor: 'pointer'}}
            onClick={(e) =>
              setWindowFnValues((prevState: any) => ({
                ...prevState,
                order: option,
              }))
            }
          >
            <Radio
              size="small"
              data-testid={`order-radio-${option}`}
              checked={windowFnValues.order === option}
              value={option}
              sx={{
                ...radioButton,
                marginTop: '0',
                paddingTop: '0',
                paddingLeft: '15px',
              }}
            />
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '12px',
                marginTop: '0',
                paddingBottom: '7px',
              }}
            >
              {option}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StandingOptions;
